import { ProductDetailActionsRenderTargetComponent } from './product-details-actions.render-target.component';
import { ProductDetailBadgesRenderTargetComponent } from './product-details-badges.render-target.component';
import { ProductDetailDefaultRenderTargetComponent } from './product-details-default.render-target.component';
import { ProductDetailExtraActionsRenderTargetComponent } from './product-details-extra-actions.render-target.component';
import { ProductDetailFooterRenderTargetComponent } from './product-details-footer.render-target.component';
import { ProductDetailHeaderRenderTargetComponent } from './product-details-header.render-target.component';
import { ProductDetailImagesRenderTargetComponent } from './product-details-images.render-target.component';
import { ProductDetailImportantInfoRenderTargetComponent } from './product-details-important-info.render-target.component';
import { ProductDetailInfoRenderTargetComponent } from './tmp/product-details-info.render-target.component';
import { ProductDetailLongDescriptionRenderTargetComponent } from '../product-details-long-description.render-target.component';
import { ProductDetailPriceRenderTargetComponent } from './tmp/product-details-price.render-target.component';
import { ProductDetailStockRenderTargetComponent } from './tmp/product-details-stock.render-target.component';
import { ProductDetailTitleRenderTargetComponent } from './product-details-title.render-target.component';
import { ProductDetailToolsRenderTargetComponent } from './tmp/product-details-tools.render-target.component';
import { ProductDetailVendorRenderTargetComponent } from './product-details-vendor.render-target.component';

export enum ProductDetailRenderTarget {
  Default = 'default',
  Header = 'header',
  Title = 'title',
  ImportantInfo = 'important-info',
  Info = 'info',
  Images = 'images',
  Footer = 'footer',
  LongDescription = 'long-description',
  Tools = 'tools',
  Badges = 'badges',
  Actions = 'actions',
  Price = 'price',
  Stock = 'stock',
  ExtraActions = 'extra-actions',
  Vendor = 'vendor',
}

export const ProductDetailRenderTargetComponents = {
  [ProductDetailRenderTarget.Default]: ProductDetailDefaultRenderTargetComponent,
  [ProductDetailRenderTarget.Header]: ProductDetailHeaderRenderTargetComponent,
  [ProductDetailRenderTarget.Title]: ProductDetailTitleRenderTargetComponent,
  [ProductDetailRenderTarget.ImportantInfo]: ProductDetailImportantInfoRenderTargetComponent,
  [ProductDetailRenderTarget.Info]: ProductDetailInfoRenderTargetComponent,
  [ProductDetailRenderTarget.Images]: ProductDetailImagesRenderTargetComponent,
  [ProductDetailRenderTarget.Footer]: ProductDetailFooterRenderTargetComponent,
  [ProductDetailRenderTarget.LongDescription]: ProductDetailLongDescriptionRenderTargetComponent,
  [ProductDetailRenderTarget.Tools]: ProductDetailToolsRenderTargetComponent,
  [ProductDetailRenderTarget.Badges]: ProductDetailBadgesRenderTargetComponent,
  [ProductDetailRenderTarget.Actions]: ProductDetailActionsRenderTargetComponent,
  [ProductDetailRenderTarget.Price]: ProductDetailPriceRenderTargetComponent,
  [ProductDetailRenderTarget.ExtraActions]: ProductDetailExtraActionsRenderTargetComponent,
  [ProductDetailRenderTarget.Stock]: ProductDetailStockRenderTargetComponent,
  [ProductDetailRenderTarget.Vendor]: ProductDetailVendorRenderTargetComponent,
} as const;
